import React, { Component } from 'react';

class PriceFormatter extends Component {
  render() {
    const { value } = this.props;
    const floatValue = parseFloat(value);
    if (floatValue || floatValue === 0) {
      return <span>{ parseFloat(roundTo(floatValue, 2)).toFixed(2) }</span>;
    }
    return <span className="label label-danger">-</span>;
  }
}

export default PriceFormatter;

function roundTo(n, digits) {
  if (digits === undefined) {
    digits = 0;
  }
  let multiplicator = Math.pow(10, digits);
  n = parseFloat((n * multiplicator).toFixed(11));
  var test =(Math.round(n) / multiplicator);
  return +(test.toFixed(2));
}



// WEBPACK FOOTER //
// ./master/jsx/components/Common/priceFormatter.jsx